<div class="agpr-pr-events-field" role="group" [attr.aria-labelledby]="id + '_header'">
    <header class="agpr-pr-events-field-header">
        <h3 class="agpr-pr-events-field-heading" [id]="id + '_header'">{{ 'Reports.prevents' | localize }}</h3>
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-pr-events-field-infoIcon"
            agprTooltip="Reports.prevents.headerTooltip"
        ></span>
    </header>
    <section *ngFor="let event of events; let i = index" class="agpr-pr-events-field-event agpr-contextMenu-parent" role="group" [attr.aria-labelledby]="id + '_event_' + i">
        <div class="agpr-contextMenu top right">
            <agpr-button
                [style]="buttonTypesEnum.contextMenu"
                icon="fa-regular fa-duotone fa-trash-can"
                tooltip="delete"
                (click)="deleteEvent(event)"
            ></agpr-button>
        </div>
        <div
            class="agpr-pr-events-field-event-header"
        >
            <h4 [id]="id + '_event_' + i" class="agpr-pr-events-field-eventHeading">{{ ('Event - ' + (i + 1)) | localize }}</h4>
        </div>
        <div class="agpr-pr-events-field-inputRow">
            <div class="agpr-pr-events-field-dropdownAndAutocompleteContainer">
                <agpr-dropdown
                    [id]="id + '.dropdown_' + i"
                    class="agpr-pr-events-field-dropdown"
                    [options]="eventTypeOptions"
                    placeholder="Reports.prevents.selectEventType"
                    [(ngModel)]="event.typeOption"
                    (ngModelChange)="handleEventTypeSelection(event, $event.value)"
                    ariaLabel="Reports.prevents.eventType"
                ></agpr-dropdown>
                <agpr-autocomplete
                    [id]="id + '.autocomplete_' + i"
                    class="agpr-pr-events-field-autocomplete"
                    [dropdown]="true"
                    [suggestions]="suggestions[event.type]"
                    labelField="name"
                    placeholder="Reports.prevents.selectEvent"
                    [disabled]="event.type === prEventTypeEnum.custom"
                    [(ngModel)]="event.model"
                    (ngModelChange)="handleEventSelection(event)"
                    [clearOnBlur]="false"
                    ariaLabel="Reports.prevents.event"
                ></agpr-autocomplete>
            </div>
        </div>
        <div class="agpr-pr-events-field-inputRow">
            <agpr-text-input
                [id]="id + '.textInput_' + i"
                placeholder="Reports.prevents.enterEventName"
                [(ngModel)]="event.name"
                ariaLabel="Reports.prevents.eventName"
            ></agpr-text-input>
        </div>
        <div class="agpr-pr-events-field-inputRow">
            <span [id]="id + '_dateHeader'" class="u-srOnly">{{'Reports.prevents.eventDate' | localize}}</span>
            <div class="agpr-pr-events-field-inputRow-calendar">
                <agpr-date-picker
                    [id]="id + '_dateInput_' + i"
                    [defaultDate]="event.date.absoluteDate"
                    [(ngModel)]="event.date.absoluteDate"
                    (ngModelChange)="emitChanges()"
                    [ariaLabelledBy]="id + '_dateHeader'"
                >
                </agpr-date-picker>
                <agpr-time-picker
                    [id]="id + '_timeInput_' + i"
                    [(ngModel)]="event.time"
                    [showTimeZoneSelector]="false"
                    [header]="'time' | localize"
                    (changeHour)="eventTimeChanged(event)"
                    (changeMinute)="eventTimeChanged(event)"
                    (changeMeridian)="eventTimeChanged(event)"
                ></agpr-time-picker>
            </div>
            <agpr-form-message *ngIf="!event.date.absoluteDate">
                {{ 'Reports.prevents.dateRequired' | localize }}
            </agpr-form-message>
        </div>
        <div class="agpr-pr-events-field-inputRow">
            <agpr-color-picker-field
                [id]="id + '.eventColorPicker_' + i"
                class="agpr-pr-events-field-colorPicker"
                [config]="{
                    ariaLabel: 'Reports.prevents.eventColor'
                }"
                [value]="event.color"
                (changes)="handleColorChange(event, $event)"
            ></agpr-color-picker-field>
        </div>
    </section>
    <div class="agpr-pr-events-field-buttonRow">
        <agpr-button
            [id]="id + '.addEventButton'"
            label="Reports.prevents.addEvent"
            [style]="buttonTypesEnum.tertiary"
            [disabled]="events.length >= maxEventCount"
            (click)="addEvent()"
        ></agpr-button>
    </div>
</div>